(function () {
    //init zoom
    toggleZoom();

    const changeTextButton = document.querySelector('.header__top-bar-zoom');
    if (changeTextButton) {
        changeTextButton.addEventListener('click', () => {
            if (sessionStorage.getItem('big-font') === 'true') {
                sessionStorage.setItem('big-font', 'false');
            } else {
                sessionStorage.setItem('big-font', 'true');
            }
            toggleZoom();
        })
    }

    function toggleZoom() {
        if (sessionStorage.getItem('big-font') === 'true') {
            document.getElementsByTagName('html')[0].classList.add('root-big-text');
        } else {
            document.getElementsByTagName('html')[0].classList.remove('root-big-text');
        }
    }
})();